import { StringEnum } from "../../utils/string-enum.js";

//#region src/shared/bricks/props/direction.ts
function direction(options = {}) {
	return StringEnum(["flex-row", "flex-col"], {
		title: "Direction",
		description: "The direction of the layout",
		enumNames: ["Horizontal", "Vertical"],
		default: "flex-row",
		"ui:styleId": "styles:direction",
		examples: ["flex-row", "flex-col"],
		...options
	});
}

//#endregion
export { direction };
//# sourceMappingURL=direction.js.map